/*
 * Check required variables
 * */
function assertRequired(value: unknown, variableName: string) {
  if (value === undefined) {
    throw Error(`Env variable ${variableName} is required`)
  }
}

/* Версия приложения из package.json */
export const APP_VERSION = import.meta.env.APP_VERSION
export const RELEASE_VERSION = import.meta.env.RELEASE_VERSION

/* API entrypoint */
export const API_URL = import.meta.env.VITE_API_URL
assertRequired(API_URL, 'VITE_API_URL')

export const APP_URL = API_URL.replace(/\/api$/, '')

/* Режим разработки */
export const isDevEnv = import.meta.env.DEV
/* Режим продакшена */
export const isProdEnv = import.meta.env.PROD

/* End-to-end тестирование */
export const isE2eTest = import.meta.env.VITE_E2E_TEST === 'true'

export const SENTRY_DSN = import.meta.env.SENTRY_DSN

export const isTestStand = import.meta.env.STAND === 'TEST'
export const isDemoStand = import.meta.env.STAND === 'DEMO'
export const isProdStand = import.meta.env.STAND === 'PROD'

export const STORE = import.meta.env.STORE
export const isRuStore = STORE === 'RU_STORE'
export const isAppStore = STORE === 'APP_STORE'

export const isMobileApp = import.meta.env.IS_MOBILE_APP === 'true'

export const DADATA_TOKEN = import.meta.env.DADATA_TOKEN

export const YANDEX_METRIKA_ACCOUNT = import.meta.env.YANDEX_METRIKA_ACCOUNT
